module.exports = __webpack_public_path__ + "static/media/Java_example.4690fe71.zip";